import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveActivity: ['activity', 'onSuccess', 'onError'],
  removeActivity: ['activity', 'onSuccess', 'onError'],
  activityError: ['error']
})

const saveActivity = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeActivity = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const activityError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.ACTIVITY_ERROR]: activityError,

  [Types.SAVE_ACTIVITY]: saveActivity,
  [Types.REMOVE_ACTIVITY]: removeActivity,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as ActivityTypes,
  Creators as ActivityActions
}
